import { ExperienceProofEntrepreneurship } from "./experienceProof";

export const experienceProofEntrepreneurshipI18n: Record<
  ExperienceProofEntrepreneurship,
  {
    title: string;
    group?: string;
    subTitle?: string;
  }
> = {
  [ExperienceProofEntrepreneurship.InformationLetterCFO]: {
    title: "application:experience.field.proof.information_letter_CFO",
    subTitle:
      "application:experience.field.proof.information_letter_CFO_subtitle",
  },
  [ExperienceProofEntrepreneurship.GrantAgreement]: {
    title: "application:experience.field.proof.grant_agreement",
  },
  [ExperienceProofEntrepreneurship.ProofOfMonetisation]: {
    title: "application:experience.field.proof.proof_of_monetisation",
    subTitle:
      "application:experience.field.proof.proof_of_monetisation_subtitle",
  },
  [ExperienceProofEntrepreneurship.ProofOfImportantPartnerships]: {
    title: "application:experience.field.proof.proof_of_important_partnerships",
    subTitle:
      "application:experience.field.proof.proof_of_important_partnerships_subtitle",
  },
  [ExperienceProofEntrepreneurship.ScreenshotsOfAppAnalytics]: {
    title: "application:experience.field.proof.screenshots_of_app_analytics",
  },
  [ExperienceProofEntrepreneurship.ProofCompanySuccess]: {
    title: "application:experience.field.proof.proof_company_success",
    subTitle:
      "application:experience.field.proof.proof_company_success_subtitle",
  },
  [ExperienceProofEntrepreneurship.SalesContract]: {
    title: "application:experience.field.proof.sales_contract",
  },
  [ExperienceProofEntrepreneurship.ProofOfRaisedFunds]: {
    title: "application:experience.field.proof.proof_of_raised_funds",
    subTitle:
      "application:experience.field.proof.proof_of_raised_funds_subtitle",
  },
};
